<template>
  <div class="calendar">
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: 'Calendar',
  components: {

  },
  props: ['end'],
  data () {
    return {
    }
  },
  methods: {
    getDays() {
      const data = [];

      let currentMonth = moment().month();
      let monthIdx = 0;
    }
  },
  mounted() {
  },
  computed: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.calendar {
  text-align: center;
  border: 1px solid gray;
  border-radius: 10px;
  margin-bottom: 50px;
}

</style>



// WEBPACK FOOTER //
// src/components/Calendar.vue